import axios from "axios";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {
  EDExam,
  examRankListParam,
  excludeExamParam,
  includeExamParam,
} from "../../models/serverModels/education/EDExam";
import {EDQuestion, QuestionListParams} from "../../models/serverModels/education/EDQuestion";

const rootApi = process.env.REACT_APP_API_KEY;

const education = axios.create({
  baseURL: rootApi,
});

export const getList = async (data: QuestionListParams): Promise<ResponseList<EDQuestion>> =>
  education({
    url: "/ExamQuestionList",
    method: "post",
    data,
  }).then((res) => res.data);

export const submit = async (
  param: Params.Create<Partial<EDExam>>
): Promise<ResponseItem<EDExam>> =>
  education({
    url: "/SubmitExamSheet",
    method: "post",
    data: param,
  }).then((res) => res.data);

export const examReport = async (params: QuestionListParams): Promise<ResponseList<EDQuestion>> => {
  return typeof params.id === "undefined"
    ? Promise.reject(new Error("id값이 없음"))
    : education({
        url: `/ExamReport/${params.id}`,
        method: "get",
        params,
      }).then((res) => res.data);
};
export const ExamRank = async (params: examRankListParam): Promise<ResponseList<EDExam>> => {
  return typeof params.id === "undefined"
    ? Promise.reject(new Error("id값이 없음"))
    : education({
        url: `/ExamRank/${params.id}`,
        method: "get",
        params,
      }).then((res) => res.data);
};
export const ExcludeExam = async (params: excludeExamParam): Promise<ResponseItem<EDExam>> => {
  return typeof params.id === "undefined"
    ? Promise.reject(new Error("id값이 없음"))
    : education({
        url: `/ExcludeExam`,
        method: "post",
        data: params,
      }).then((res) => res.data);
};
export const IncludeExam = async (params: includeExamParam): Promise<ResponseItem<EDExam>> => {
  return typeof params.id === "undefined"
    ? Promise.reject(new Error("id값이 없음"))
    : education({
        url: `/IncludeExam`,
        method: "post",
        data: params,
      }).then((res) => res.data);
};

export const getScore = async (params: Params.GetItem): Promise<ResponseItem<string>> =>
  education({
    url: `/ExamScoreTable/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
